// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iBWMFI = 'iBWMFI';
export class IBWMFI extends iBuildInIndicator {
    constructor() {
        super(1);
    }
    get Name() {
        return iBWMFI;
    }
    OnQuote() {
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        if (Parent != null) {
            const volume = Parent.GetVolume(0);
            if (volume !== 0) {
                this.SetValue((this.GetPrice(PriceType.High, 0) - this.GetPrice(PriceType.Low, 0)) /
                    (volume * this.FParent.Instrument.PointSize));
            }
        }
    }
}
